import { render } from "./ResponsiveMultiSelect.vue?vue&type=template&id=2e2494b2&scoped=true"
import script from "./ResponsiveMultiSelect.vue?vue&type=script&lang=js"
export * from "./ResponsiveMultiSelect.vue?vue&type=script&lang=js"

import "./ResponsiveMultiSelect.vue?vue&type=style&index=0&id=2e2494b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2494b2"]])

export default __exports__